var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTshirt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0936 19.9918C18.0936 20.5486 17.6389 21 17.078 21H6.92201C6.36111 21 5.90641 20.5486 5.90641 19.9918V8.90201L3.95103 9.54904C3.3715 9.7408 2.7538 9.38496 2.63399 8.79032L2.01985 5.74208C1.9194 5.2435 2.20868 4.7487 2.6946 4.58793L7.11854 3.12421C7.64847 2.94888 8.22298 2.95944 8.746 3.15414C10.844 3.93514 13.156 3.93514 15.254 3.15414C15.777 2.95944 16.3515 2.94888 16.8815 3.12421L21.3054 4.58793C21.7913 4.7487 22.0806 5.2435 21.9801 5.74208L21.366 8.79032C21.2462 9.38496 20.6285 9.7408 20.049 9.54904L18.0936 8.90201V19.9918Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshirt);
export default __webpack_public_path__ + "static/media/tshirt.6f7dd6c1085d532e2e70f36fcfea3a05.svg";
export { ForwardRef as ReactComponent };